package org.hs_soft.runmynesto.domain.model.menu

import org.hs_soft.runmynesto.data.local_datasource.menu_data.MenuFooterData
import org.hs_soft.runmynesto.data.local_datasource.menu_data.MenuHeaderData
import org.hs_soft.runmynesto.domain.config.Theme
import org.jetbrains.compose.web.css.CSSColorValue
import kotlin.enums.EnumEntries

data class MenuModel(
    val menuItemsData: EnumEntries<MenuItemsEnum> = MenuItemsEnum.entries,
    val footerData: MenuFooterModel = MenuFooterData.data,
    val menuHeaderData: MenuHeaderModel = MenuHeaderData.data,
    val hoverColor: CSSColorValue = Theme.ActionHover.rgb,
    val clickedIconColor:CSSColorValue=Theme.ActionDisabledBackground.rgb,
//    val iconTint:String = Theme.Transparent.hex,
    val clickedItemBackground:CSSColorValue= Theme.PrimaryStatesSelected.rgb,
    val footerBackground:CSSColorValue= Theme.Transparent.rgb,
    val menuBackground:CSSColorValue= Theme.Transparent.rgb,
    val headerBackground:CSSColorValue= Theme.Transparent.rgb,
)
